"use client"

import * as React from "react"
import {useEffect, useMemo, useState} from "react"
import _ from "lodash";
import {Button} from "@/components/ui/button"
import {ClipLoader} from "react-spinners";
import {Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle} from "@/components/ui/card";
import {Label} from "@/components/ui/label";
import useWorkflows from "@/query/workflow/useWorkflows";
import useDefaultAdminSetting from "../../query/adminSetting/useDefaultAdminSetting";
import workflowRepository from "@/repository/WorkflowRepository";
import Combobox from "@/components/ui/combobox";
import useCreateDefaultAdminSetting from "../../query/adminSetting/useCreateDefaultAdminSetting";
import toast from "react-hot-toast";
import {Workflow} from "@/model/Workflow";

const WorkspaceCommonSettingView = () => {

    const {data: adminSetting} = useDefaultAdminSetting()

    const [defaultWorkflows, setDefaultWorkflows] = useState<{defaultChatWorkflow: Workflow} | undefined>(undefined)
    const [defaultClusterWorkflows, setDefaultClusterWorkflows] = useState<{defaultClusterWorkflow: Workflow} | undefined>(undefined)

    useEffect(() => {
        if (!adminSetting) return undefined

        workflowRepository.find([adminSetting.defaultChatWorkflowId]).then(({data}) => {
            const defaultChatWorkflow = data.result.find((workflow: Workflow) => workflow._id === adminSetting.defaultChatWorkflowId)
            setDefaultWorkflows({defaultChatWorkflow: defaultChatWorkflow})
        })

        workflowRepository.find([adminSetting.defaultKeywordClusterWorkflowId]).then(({data}) => {
            const defaultClusterWorkflow = data.result.find((workflow: Workflow) => workflow._id === adminSetting.defaultKeywordClusterWorkflowId)
            setDefaultClusterWorkflows({defaultClusterWorkflow: defaultClusterWorkflow})
        })

    }, [adminSetting])

    if (defaultWorkflows && defaultClusterWorkflows) {
        return <AdminSettingCard defaultChatWorkflow={defaultWorkflows.defaultChatWorkflow}
                                 defaultClusterWorkflow={defaultClusterWorkflows.defaultClusterWorkflow}/>
    } else {
        return (
            <div className='flex items-center justify-center'>
                <ClipLoader color={'grey'}/>
            </div>
        )
    }

}

const AdminSettingCard: React.FC<{ defaultChatWorkflow: Workflow, defaultClusterWorkflow: Workflow }> = ({defaultChatWorkflow, defaultClusterWorkflow}) => {

    const [workflowName, setWorkflowName] = useState<string>("")
    const {data: chatWorkflow} = useWorkflows({name: workflowName, labels: ['sitebunny-chat']})
    const {data: keywordClusterWorkflow} = useWorkflows({name: workflowName, labels: ['sitebunny-keyword-cluster']})

    const [selectedWorkflow, setSelectedWorkflow] = useState<Workflow>(defaultChatWorkflow)
    const [selectedClusterWorkflow, setSelectedClusterWorkflow] = useState<Workflow>(defaultClusterWorkflow)

    const chatWorkflows = useMemo(() => {
        return chatWorkflow?.pages.map((page) => page.content).flat()
    }, [chatWorkflow])

    const keywordClusterWorkflows = useMemo(() => {
        return keywordClusterWorkflow?.pages.map((page) => page.content).flat()
    },[keywordClusterWorkflow])

    const {mutateAsync: onSubmit} = useCreateDefaultAdminSetting(selectedWorkflow._id, selectedClusterWorkflow._id)

    const onChange = _.debounce((search: string) => {
        setWorkflowName(search);
    }, 300);

    return (
        <Card>
            <CardHeader>
                <CardTitle>관리자 설정</CardTitle>
                <CardDescription>...</CardDescription>
            </CardHeader>
            <CardContent>
                <div className="grid w-full items-center gap-4">
                    <Label htmlFor="framework">Default Chat</Label>
                    <Combobox placeholder={selectedWorkflow
                        ? selectedWorkflow.name
                        : "Select Workflow..."}
                              onChangeQuery={onChange}
                              items={chatWorkflows ? chatWorkflows.map((workflow) => ({label: workflow.name || '', value: workflow._id})) : []}
                              onChangeValue={(selectedWorkflowId) => {

                                  const _selectedWorkflow = chatWorkflows?.find((workflow) => workflow._id === selectedWorkflowId)
                                  if (_selectedWorkflow) {
                                      setSelectedWorkflow(_selectedWorkflow)
                                  }
                              }}
                    />

                    <Label htmlFor="framework">Default Keyword Clustering</Label>
                    <Combobox placeholder={selectedClusterWorkflow
                        ? selectedClusterWorkflow.name
                        : "Select Workflow..."}
                              onChangeQuery={onChange}
                              items={keywordClusterWorkflows ? keywordClusterWorkflows.map((workflow) => ({label: workflow.name || '', value: workflow._id})) : []}
                              onChangeValue={(selectedWorkflowId) => {

                                  const _selectedWorkflow = keywordClusterWorkflows?.find((workflow) => workflow._id === selectedWorkflowId)
                                  if (_selectedWorkflow) {
                                      setSelectedClusterWorkflow(_selectedWorkflow)
                                  }
                              }}
                    />

                    <Label className='text-gray-500' htmlFor="framework">Default Create Welcome</Label>
                    <Combobox items={[]} onChangeValue={() => {}} onChangeQuery={() => {}}/>
                </div>

            </CardContent>
            <CardFooter className="flex justify-end">
                <Button onClick={() => {onSubmit().then(() => {
                    toast.success("저장")
                }).catch(() => {
                    toast.error("에러")
                })}}>저장</Button>
            </CardFooter>
        </Card>
    )
}

export default WorkspaceCommonSettingView;